var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIraContributionsComplete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9732 48.56L1.52002 72.2864L15.1159 69.4653L19.1947 82.16L31.76 63.3422",
    stroke: "#05C3DE",
    strokeWidth: 2.75,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.355 50.24L82.16 70.8066L68.5833 69.3874L64.4057 82.16L53.6 63.6057",
    stroke: "#05C3DE",
    strokeWidth: 2.75,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.44 33.44C75.44 51.0696 61.1481 65.36 43.52 65.36C25.8904 65.36 11.6 51.0696 11.6 33.44C11.6 15.8119 25.8904 1.52002 43.52 1.52002C61.1481 1.52002 75.44 15.8119 75.44 33.44Z",
    stroke: "#05C3DE",
    strokeWidth: 2.75,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.52 18.32L49.0182 29.3164H58.64L50.3928 36.1891L54.5164 48.56L43.52 41.6694L32.5237 48.56L36.6473 36.1891L28.4 29.3164H38.0218L43.52 18.32Z",
    stroke: "#05C3DE",
    strokeWidth: 2.75,
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIraContributionsComplete);
export default __webpack_public_path__ + "static/media/ira-contributions-complete.5c7221693ee28dfdc8205e2d45c42a5e.svg";
export { ForwardRef as ReactComponent };